module.exports = __webpack_public_path__ + "static/media/icon_dna_analysis.231592b7.svg";